import { captureException } from '@sentry/browser'

function initialState() {
  return {
    loading: false,
    error: null,
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions: {
  // @ts-expect-error
    resetState({ commit }) {
      commit('RESET_STATE')
    },

    // @ts-expect-error
    setLoading({ commit }, payload) {
      commit(
        'SET_LOADING',
        payload,
      )
    },
    // @ts-expect-error
    clearError({ commit }) {
      commit('CLEAR_ERROR')
    },
    // @ts-expect-error
    setError({ commit }, error) {
      captureException(error)
      commit(
        'SET_ERROR',
        error,
      )
    },

    // @ts-expect-error
    init({ commit }) {
      commit('CLEAR_ERROR')
      commit(
        'SET_LOADING',
        true,
      )
    },
    // @ts-expect-error
    success({ commit }) {
      commit(
        'SET_LOADING',
        false,
      )
    },
    // @ts-expect-error
    error({ commit }, error) {
      commit(
        'SET_ERROR',
        error,
      )
      commit(
        'SET_LOADING',
        false,
      )
    },
  },
  mutations: {
    RESET_STATE(_state: any) {
      Object.assign(
        _state,
        initialState(),
      )
    },

    // @ts-expect-error
    SET_LOADING(state: any, payload) {
      state.loading = payload
    },
    // @ts-expect-error
    SET_ERROR(state: any, payload) {
      state.error = payload
    },
    CLEAR_ERROR(state: any) {
      state.error = null
    },
  },
}
